"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DivCropped = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var RelativeWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n"], ["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n"])));
var AbsoluteWrapper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n"], ["\n  position: absolute;\n"])));
/**
 * @description
 * 画像の切り抜きを「拡大＆はみ出た部分を隠す」で実装している．
 *
 *     0
 *   0 +----------------------+
 *     |    l                 |
 *     |  t +-----+           |
 *     |    |     | h         | 1
 *     |    +-----+           |
 *     |       w              |
 *     |                      |
 *     +----------------------+
 *                1
 *
 *                ↓
 *
 *
 *     L
 *   T +----------------------+
 *     |    0                 |
 *     |  0 +-----+           |
 *     |    |     | 1         | H
 *     |    +-----+           |
 *     |       1              |
 *     |                      |
 *     +----------------------+
 *                W
 *
 * H = 1 / h
 * W = 1 / w
 * T + H * t = 0  =>  T = -H * t
 * L + W * l = 0  =>  L = -W * l
 */
exports.DivCropped = (0, react_1.memo)(function (_a) {
    var component = _a.component, cropRectRelative = _a.cropRectRelative;
    var zoomedImgStyle = (0, react_1.useMemo)(function () {
        var width = cropRectRelative.width, height = cropRectRelative.height, top = cropRectRelative.top, left = cropRectRelative.left;
        var W = 1 / width;
        var H = 1 / height;
        var L = -W * left;
        var T = -H * top;
        return {
            width: "".concat(W * 100, "%"),
            height: "".concat(H * 100, "%"),
            top: "".concat(T * 100, "%"),
            left: "".concat(L * 100, "%")
        };
    }, [cropRectRelative]);
    return (react_1.default.createElement(RelativeWrapper, null,
        react_1.default.createElement(AbsoluteWrapper, { style: zoomedImgStyle }, component)));
});
exports.DivCropped.displayName = 'DivCropped';
var templateObject_1, templateObject_2;
